export const ADMISSION_WELCOME_ROUTE = "/admission/welcome";
